import React from 'react';
import clsx from 'clsx';
import { Dropdown } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { states } from '@/constants/lifecycle';

const listItems = (datasets) => datasets.map((dataset) => ({
  key: `dataset_dropdown_item_${dataset.code}`,
  text: dataset.catalogue.title,
  value: dataset.code,
  description: dataset.code,
}));

const CollectionDatasetsDropdown = ({
  autoFocus,
  className,
  datasets,
  disabled,
  filter,
  onChange,
  onFilterChange,
  readStatus,
  text,
}) => {
  const intl = useIntl();
  return (
    <Dropdown
      autoFocus={autoFocus}
      className={clsx('aridhia-collection-datasets-dropdown mt-0', className)}
      disabled={disabled}
      fluid
      loading={readStatus === states.PENDING}
      multiple
      noResultsMessage={intl.formatMessage({ id: 'find.datasets.none' })}
      onChange={(e, { value }) => { onChange(value); }}
      onSearchChange={
        (e, { searchQuery }) => { onFilterChange(searchQuery); }
      }
      options={listItems(datasets)}
      placeholder={intl.formatMessage({ id: 'find.datasets.placeholder' })}
      search={(options) => options}
      searchQuery={filter}
      selection
      size="large"
      value={text}
    />
  );
};

export default CollectionDatasetsDropdown;
